import React, { useState } from "react";
import axios from "axios";
import { AllContext } from "../contexts/DataContext";
import { useNavigate } from "react-router-dom";
import { IoReloadSharp, IoCloseSharp, IoEye, IoEyeOff } from "react-icons/io5";

function Register() {
  const { setVerifyAuth, setVerifyId, setVerifyEmail, url } = AllContext();
  const navigate = useNavigate();

  const data = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    passwd: "",
  };
  const [togglePwd, setTogglePwd] = useState(false);
  const [reg, setReg] = useState(data);
  const [errMsg, setErrMsg] = useState(false);
  const [errReg, setErrReg] = useState("");
  const [load, setLoad] = useState(false);
  const saveData = [...Object.values(reg)].every(Boolean);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let val = value.trim();
    setReg((prevData) => ({
      ...prevData,
      [name]: val,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!saveData) {
      setErrMsg((err) => (err = true));
      return;
    }
    setLoad(true);
    try {
      const resp = await axios.post(`${url}/selfpace/register`, reg);
      if (resp.data.type !== "SUCCESS") {
        setLoad(false);
        setErrReg(resp.data.msg);
        return;
      }
      const { id } = resp.data.data;
      setErrReg("");
      setVerifyAuth(true);
      sessionStorage.setItem("currentlyLogged", reg.email);
      setLoad(false);
      setVerifyEmail(reg.email);
      setVerifyId(id);
      setReg(data);
      navigate("/email/verify");
    } catch (error) {
      setErrReg("OOPs! There was a problem with the registration.");
      setLoad(false);
    }
  };

  const handleTogglePwd = () => {
    setTogglePwd(!togglePwd);
  };

  return (
    <div className="reg__form-container">
      <div className="container spaceTop">
        <div className="reg__form-header">
          <h2>Create an account</h2>
        </div>
        <form action="POST" className="reg__form" onSubmit={handleSubmit}>
          <div className="reg__form-sub">
            <div className="reg__form-control">
              <label htmlFor="first_name">First Name</label>
              <input
                type="text"
                name="first_name"
                className={errMsg && reg.first_name === "" ? "form_error" : ""}
                onChange={handleChange}
                value={reg.first_name}
                required
              />
              {errMsg && reg.first_name === "" ? <span>Field Required</span> : null}
            </div>
            <div className="reg__form-control">
              <label htmlFor="last_name">Last Name</label>
              <input type="text" name="last_name" className={errMsg && reg.last_name === "" ? "form_error" : ""} onChange={handleChange} value={reg.last_name} required />
              {errMsg && reg.last_name === "" ? <span>Field Required</span> : null}
            </div>
          </div>
          <div className="reg__form-control">
            <label htmlFor="phone">Phone Number</label>
            <input type="text" name="phone" className={errMsg && reg.phone === "" ? "form_error" : ""} onChange={handleChange} value={reg.phone} required />
            {errMsg && reg.phone === "" ? <span>Field Required</span> : null}
          </div>
          <div className="reg__form-control">
            <label htmlFor="email">Email</label>
            <input type="email" name="email" className={errMsg && reg.email === "" ? "form_error" : ""} onChange={handleChange} value={reg.email} required />
            {errMsg && reg.email === "" ? <span>Invalid Email Address</span> : null}
          </div>
          <div className="reg__form-control reg__form-pwd">
            <label htmlFor="password">Password</label>
            <input
              type={!togglePwd ? "password" : "text"}
              name="passwd"
              className={errMsg && reg.passwd === "" ? "form_error" : ""}
              onChange={handleChange}
              value={reg.passwd}
              required
            />
            {errMsg && reg.passwd === "" ? <span>Password must be at least 8 characters</span> : null}
            {togglePwd ? (
              <button className="toggle_pwd" type="button" onClick={handleTogglePwd}>
                <IoEye />
              </button>
            ) : (
              <button className="toggle_pwd" type="button" onClick={handleTogglePwd}>
                <IoEyeOff />
              </button>
            )}
          </div>
          <div className="reg__form-btn">
            <button>{load ? <IoReloadSharp className="form-spinner" /> : "Submit"}</button>
          </div>
        </form>
        {errReg && (
          <div className="err_form_msg">
            <span>{errReg}</span>
            <button className="err_form_msg_btn" onClick={() => setErrReg("")}>
              <IoCloseSharp />
            </button>
          </div>
        )}
      </div>
      <div className="space"></div>
    </div>
  );
}

export default Register;
